/* eslint-disable */

/*
 * This is a generated file created by deere-ui-svg-to-react.
 *
 * Please do not modify this file directly as it will be regenerated at build time.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

exports["default"] = _react2["default"].createClass({
    displayName: "info",

    getDefaultProps: function getDefaultProps() {
        return {
            "st0": {
                "fill": "#666767"
            },
            "st1": {
                "fillRule": "evenodd",
                "clipRule": "evenodd",
                "fill": "#676767"
            },
            "info": {
                "backgroundImage": "none",
                "backgroundPosition": "0% 0%",
                "display": "inline",
                "fill": "#333"
            },
            "width": "24",
            "height": "24"
        };
    },

    render: function render() {
        return _react2["default"].createElement(
            "svg",
            { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", className: "info", width: this.props.width, height: this.props.height, style: this.props.info },
            _react2["default"].createElement("path", { className: "st0", d: "M11.9 24c-1.1 0-2.2-.1-3.2-.4-1-.3-2-.7-2.9-1.2-.9-.5-1.7-1.1-2.4-1.9-.7-.7-1.4-1.5-1.9-2.4-.5-.9-.9-1.8-1.2-2.9-.3-1-.4-2.1-.4-3.2S0 9.8.3 8.8c.3-1 .7-2 1.2-2.8.5-.9 1.1-1.7 1.9-2.4.8-.7 1.6-1.3 2.5-1.9.9-.5 1.8-.9 2.9-1.2 1-.3 2.1-.4 3.2-.4s2.2.1 3.2.4c1 .3 2 .7 2.9 1.2.9.5 1.7 1.1 2.4 1.9.7.7 1.3 1.5 1.9 2.4.5.9.9 1.8 1.2 2.8.3 1 .4 2.1.4 3.2s-.1 2.2-.4 3.2c-.3 1-.7 2-1.2 2.9-.5.9-1.1 1.7-1.9 2.4-.7.7-1.5 1.3-2.4 1.9-.9.5-1.8.9-2.9 1.2s-2.2.4-3.3.4M5.2 5.4c-.4.4-.8.9-1.1 1.4-.3.5-.6 1-.9 1.6-.5 1.2-.7 2.4-.7 3.7 0 .6.1 1.3.2 1.9.1.6.3 1.2.5 1.8.2.6.5 1.1.9 1.6.3.5.7 1 1.1 1.4.9.9 1.9 1.6 3 2 .6.3 1.2.4 1.8.6.6.1 1.2.2 1.9.2.6 0 1.3-.1 1.9-.2.6-.1 1.2-.3 1.8-.6.5-.2 1.1-.5 1.6-.8.5-.3 1-.7 1.4-1.2.4-.4.8-.9 1.1-1.4.3-.5.6-1 .9-1.6l.6-1.8c.1-.6.2-1.2.2-1.9 0-.6-.1-1.3-.2-1.9-.2-.6-.4-1.2-.7-1.8-.2-.6-.5-1.1-.9-1.6-.3-.5-.7-1-1.1-1.4-.4-.4-.9-.8-1.4-1.1-.5-.3-1-.6-1.6-.8-.5-.3-1.1-.5-1.7-.6-.6-.1-1.2-.2-1.9-.2s-1.3.1-1.9.2c-.6.1-1.2.3-1.7.5-.6.2-1.1.5-1.6.9-.6.3-1 .7-1.5 1.1", style: this.props.st0 }),
            _react2["default"].createElement("path", { className: "st1", d: "M10.4 5.7h3v3h-3zM10.4 10.2h3v7.6h-3z", style: this.props.st1 })
        );
    }
});

/* eslint-enable */
module.exports = exports["default"];



// WEBPACK FOOTER //
// ./~/cap-it-ui.toggles/~/cap-it-ui.icons/lib/info.js